import type { ItemRow } from '../components/ItemsTable'

/**
 * Строка формы «Новая заявка» заполнена — в ней есть хоть что-то от менеджера.
 *
 * Форма всегда держит одну пустую строку-заготовку (`makeEmptyRow`), и она
 * отмечена галочкой. Раньше такая заготовка считалась полноценной позицией:
 * автосохранение черновика и «Создать заявку» записывали её в БД, а пустой
 * партномер превращался в «???» — в заявке появлялась мусорная позиция
 * «??? / 1 pcs / без бренда» вместо позиций менеджера (жалоба 15.09.2026).
 *
 * Количество и единицу не смотрим: у заготовки они заполнены по умолчанию
 * (1 pcs) и «заполненности» строки не означают.
 */
export function isRowFilled(row: ItemRow): boolean {
  return Boolean(row.partNumber.trim() || row.brand.trim() || row.note.trim())
}
